(function() {
  var store;
  var __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
  store = window.Store || (window.Store = {});
  store.Views = store.Views || (store.Views = {});
  store.Views.ImageView = Backbone.View.extend({
    initialize: function(options) {
      this.$el = $(this.el);
      this.$el.fadeTo(0, 0);
      if (this.el.complete) {
        this.imageLoaded();
      } else {
        this.$el.load(__bind(function() {
          return this.imageLoaded();
        }, this));
      }
    },
    imageLoaded: function() {
      this.$el.fadeTo(400, 1);
    }
  });
}).call(this);
